/**
 * Centralized tool icon mapping
 * Maps tool IDs to their respective icons for the UI
 */

import {
  IconPhoto,
  IconPhotoFilled,
  IconWorld,
  IconWorldOff,
  IconVideo,
  IconVideoFilled,
  IconMusic,
  IconBrandThreejs,
  IconBoltFilled,
  IconDeviceLaptop,
  IconRobot
} from '@tabler/icons-react'

interface ToolIconConfig {
  enabledIcon: JSX.Element
  disabledIcon: JSX.Element
}

// Map tool IDs to their icon configurations
export const TOOL_ICON_MAP: Record<string, ToolIconConfig> = {
  // Web Browsing
  'b3f07a6e-5e01-423e-9f06-ee51830608be': {
    enabledIcon: <IconWorld size={20} className="text-black dark:text-white" stroke={2.3} />,
    disabledIcon: <IconWorldOff size={20} className="text-muted-foreground" stroke={2} />
  },

  // Create Images (Unified Image Generator)
  'b3f07a6e-5e01-423e-1f05-ee51830608gf': {
    enabledIcon: <IconPhotoFilled size={20} className="text-black dark:text-white" stroke={2.3} />,
    disabledIcon: <IconPhoto size={20} className="text-muted-foreground" stroke={2} />
  },

  // DALL-E 3 (Image Generator)
  'b3f07a6e-5e01-423e-1f05-ee51830608be': {
    enabledIcon: <IconPhotoFilled size={20} className="text-black dark:text-white" stroke={2.3} />,
    disabledIcon: <IconPhoto size={20} className="text-muted-foreground" stroke={2} />
  },

  // Create Videos
  'b3f07a6e-5e01-423e-1f05-ee51830608vc': {
    enabledIcon: <IconVideoFilled size={20} className="text-black dark:text-white" stroke={2.3} />,
    disabledIcon: <IconVideo size={20} className="text-muted-foreground" stroke={2} />
  },

  // Audio Tool
  'audio-tool-v1': {
    enabledIcon: <IconMusic size={20} className="text-black dark:text-white" stroke={2.3} />,
    disabledIcon: <IconMusic size={20} className="text-muted-foreground" stroke={2} />
  },

  // Losi Computer
  sandbox: {
    enabledIcon: (
      <IconDeviceLaptop size={20} className="text-black dark:text-white" stroke={2.3} />
    ),
    disabledIcon: <IconDeviceLaptop size={20} className="text-muted-foreground" stroke={2} />
  },

  // 3D Asset Generator
  '3d-asset-generator-v1': {
    enabledIcon: <IconBrandThreejs size={20} className="text-black dark:text-white" stroke={2.3} />,
    disabledIcon: <IconBrandThreejs size={20} className="text-muted-foreground" stroke={2} />
  },

  // Task Automation
  'b3f07a6e-5e01-423e-1f05-ee51830608ff': {
    enabledIcon: <IconBoltFilled size={20} className="text-black dark:text-white" stroke={2.3} />,
    disabledIcon: <IconRobot size={20} className="text-muted-foreground" stroke={2} />
  }
}

/**
 * Get icon configuration for a tool by its ID
 */
export function getToolIcons(toolId: string): ToolIconConfig | null {
  return TOOL_ICON_MAP[toolId] || null
}

/**
 * Check if a tool has icon mapping (should be shown in quick actions dropdown)
 */
export function toolHasIcon(toolId: string): boolean {
  return toolId in TOOL_ICON_MAP
}
